import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsNhomNhanSu } from '../../services/danhmuc';

const NhomNhanSuSelectBox = ({ value, optionAll, disabled, onChange, allowClear }: { value?: number, optionAll?: boolean, disabled?: boolean, onChange: (e: any) => void, allowClear?: boolean }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsNhomNhanSu();
            if (optionAll && rs.length > 1) {
                rs = [{ value: 0, label: "--Tất cả--" }, ...rs];
            }
            const isValidValue = rs.some(x => x.value === value);

            if (!isValidValue) {
                onChange({
                    target: {
                        name: name,
                        value: null
                    }
                })
            }
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        <Select
            style={{ width: '100%', height: '35px' }}
            showSearch
            placeholder="--Chọn nhóm nhân sự--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            options={data}
            disabled={disabled}
            value={value}
            onChange={(e: number) => {
                onChange({
                    target: {
                        name: name,
                        value: e
                    }
                })
            }}
            allowClear={allowClear }
        />
    );
};

export default NhomNhanSuSelectBox;
